import createGetFormSyncWarnings from './selectors/getFormSyncWarnings';
import plain from './structure/plain';

export default createGetFormSyncWarnings(plain);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/getFormSyncWarnings.js
// module id = 1757
// module chunks = 2